import * as Sentry from '@sentry/browser'
import { setUserSettings } from '../profile/db/userProfile'
import { getSettings } from './api'
import { overrideUserAddressGroups } from './db/userAddressGroups'

const syncSettings = async (): Promise<void> => {
  try {
    const settings = await getSettings()

    await overrideUserAddressGroups(
      settings.addressGroupIds.map((id) => {
        return {
          id: id,
        }
      })
    )

    await setUserSettings({
      timeTrackingDefaultProjectCostCenterSelectionView:
        settings.timeTrackingDefaultProjectCostCenterSelectionView,
      articleDialogDefaultSelectionView:
        settings.articleDialogDefaultSelectionView,
    })
  } catch (error: any) {
    if (error.response?.status === 401) {
    } else {
      Sentry.captureException(error)
    }
  }
}

export { syncSettings }
